<template>
  <div class="w-full flex flex-col">
    <form-edit-header v-model="form_name" :flowable="form.type === 'flowform'" active-index="4" />
    <auth-manage />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import zroute from '../../ziggy'
import FormEditHeader from '../../components/FormEditHeader'
import axios from 'axios'
import AuthManage from '../../components/AuthManage'

export default {
  name: 'FormData',
  components: {AuthManage, FormEditHeader},
  layout: Layout,
  props: {
    form: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      form_name: this.form.name,
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="stylus" scoped>

</style>
